import CurrencyIcon from "@/components/icons/CurrencyIcon";
import { useRouter } from "next/router";

/**
 * Renders a price value next to the Riyal currency icon with correct icon
 * placement per locale: icon on the LEFT for English, unchanged for Arabic.
 *
 * DOM order is always [amount][icon]. For `en` we add `flex-row-reverse` so the
 * icon visually lands on the left. For `ar` the ambient `dir=rtl` already flips
 * a default flex row, so the icon stays on the left exactly as before — no extra
 * class is added and Arabic rendering is untouched.
 *
 * @param amount        the (already formatted) price node/text
 * @param iconClassName size/styling classes for the icon (kept per call-site)
 * @param iconStyle     inline style for the icon (sub-pixel sizes only)
 * @param className     extra wrapper classes — pass the caller's original gap
 *                      (e.g. "gap-1"/"gap-0.5") here to preserve spacing
 * @param showIcon      hide the icon for non-numeric values (dash / "Free")
 * @param as            wrapper tag (defaults to span)
 */
const PriceWithCurrency = ({
  amount,
  iconClassName = "",
  iconStyle,
  className = "",
  showIcon = true,
  as: Tag = "span",
}) => {
  const { locale } = useRouter();
  return (
    <Tag
      className={`inline-flex items-center ${
        locale === "en" ? "flex-row-reverse" : ""
      } ${className}`}
    >
      <span>{amount}</span>
      {showIcon && <CurrencyIcon className={iconClassName} style={iconStyle} />}
    </Tag>
  );
};

export default PriceWithCurrency;
